export const passwordRotationOptions = [
    {
        label: '30 days',
        value: '30',
    },
    {
        label: '60 days',
        value: '60',
    },
    {
        label: '90 days',
        value: '90',
    },
]

export const sessionInactivityOptions = [
    {
        label: '15 minutes',
        value: '15',
    },
    {
        label: '30 minutes',
        value: '30',
    },
]

export const applicationAccessOptions = [
    {
        value: 'Finance Manager',
        name: 'All dealership apps',
    },
    {
        value: 'Default',
        name: "User's own applications",
    },
    {
        value: 'Administrator',
        name: 'All dealership chain apps',
    },
    {
        value: 'Sales',
        name: 'No portal access',
    },
]

export const levelOfAccessOptions = [
    {
        name: 'Admin',
        value: 'Admin',
    },
    {
        name: 'Teammate',
        value: 'Teammate',
    },
    {
        name: 'Sales',
        value: 'Sales',
    },
]

export const LEVEL_OF_ACCESS_SALES = 'Sales'
export const LEVEL_OF_ACCESS_ADMIN = 'Admin'
export const LEVEL_OF_ACCESS_REGIONAL_MANAGER = 'Regional Manager'
export const APPLICATION_ACCESS_OWN_APPS = 'Default'
export const APPLICATION_ACCESS_REGION_APPS = 'Regional Manager'
export const APPLICATION_ACCESS_ALL_CHAIN_APPS = 'Administrator'
